<template>
    <div>
        <p>
            <el-image style="height: 45px; width: 45px; border-radius: 75px;border: rgb(241,242,244) solid 1px;"
                      :src="iconPath && iconPath.indexOf('http') == -1 ? dynamicPath + iconPath : iconPath">
                <div slot="error" class="image-slot">
                    <el-image title="加载失败"
                              src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/qunyiguan/c6d05d1e8c33703186ec1f89743f979.png"/>
                </div>
            </el-image>
        </p>
        <p>昵称：{{ nickname || '已失效' }}</p>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                dynamicPath: config.dynamicResourcePath,
            }
        },
        props: {
            // 用户头像
            iconPath: {
                type: String,
                required: false
            },
            // 用户昵称
            nickname: {
                type: String,
                required: false
            },
        },
    }
</script>
<style scope>
    .pagination {
        margin-top: 0;
    }
</style>
